import { FormattedMessage, useIntl } from "react-intl";
import Toast from "../../../../common/core-ui/Toast.tsx";
import BaseLinkOrButton from "../../../../common/core-ui/BaseLinkOrButton.tsx";
import { getOptOutErrorLink } from "./links.ts";

export default function DefaultErrorToast({
  onClose,
}: {
  onClose?: () => void;
}) {
  const intl = useIntl();
  return (
    <Toast
      onClose={onClose}
      type="error"
      title={intl.formatMessage({
        defaultMessage: "Your change could not be saved.",
      })}
    >
      <FormattedMessage defaultMessage="We are working on it. Please try again tomorrow." />
      <BaseLinkOrButton href={getOptOutErrorLink()} className="vst-link">
        <FormattedMessage defaultMessage="More Info" />
      </BaseLinkOrButton>
    </Toast>
  );
}
